var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHeart = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 26 23"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M25 7.84a6.84 6.84 0 0 1-1.985 4.818c-2.93 2.952-5.77 6.03-8.809 8.875a1.79 1.79 0 0 1-2.467-.053l-8.754-8.822a6.844 6.844 0 0 1 0-9.638 6.83 6.83 0 0 1 9.697 0l.318.32.318-.32a6.83 6.83 0 0 1 9.697 0A6.84 6.84 0 0 1 25 7.84"
})));
export default SvgHeart;